import {useTranslation} from "ni18n";
import React from "react";
import useMediaQuery from "src/useMediaQuery";

import SectionHeader from "../About/SectionHeader";
import NextImage from "../NextImage";

const OurBenefits: React.VoidFunctionComponent = () => {
  const i18n = useTranslation();

  const data = [
    {
      header: i18n.t("Comprehensive health & wellness plans"),
      text: i18n.t(
        "We offer programs and resources to support your overall health and well-being.",
      ),
      img: "illustrations/happy-healthy-person-smiling",
      alt: i18n.t("Illustration of a happy healthy person smiling."),
    },
    {
      header: i18n.t("Competitive compensation & perks"),
      text: i18n.t("We are committed to ensuring fair and equitable pay for all employees."),
      img: "/illustrations/piggy-bank",
      alt: i18n.t("Illustration of a hand dropping a coin into a piggy bank."),
    },
    {
      header: i18n.t("Collaborative & inclusive culture"),
      text: i18n.t(
        "We value the minds, experiences, and perspectives of people from all walks of life.",
      ),
      img: "illustrations/hands",
      alt: i18n.t("Illustration of hands coming together in a team cheer formation."),
    },
    {
      header: i18n.t("Career growth & development"),
      text: i18n.t(
        "We want to empower you with tools, resources, and feedback to help you reach new heights.",
      ),
      img: "illustrations/laptop-with-cactus",
      alt: i18n.t(
        "Illustration of a small plant and an open laptop with a positive growth graph on the screen.",
      ),
    },
    {
      header: i18n.t("Learning resources to be your best self"),
      text: i18n.t(
        "Our ongoing learning opportunities, including Udemy Business and Learning Time Off program, support your personal and professional growth.",
      ),
      img: "illustrations/person-at-laptop",
      alt: i18n.t("Illustration of a person sitting in front of their laptop taking notes."),
    },
    {
      header: i18n.t("Work from location, home, or office"),
      text: i18n.t(
        "With remote, on-site, and hybrid roles, our flexible work culture is designed to accommodate your unique needs and lifestyle, so you can be successful in your role.",
      ),
      img: "illustrations/person-in-wheelchair-with-computer",
      alt: i18n.t(
        "Illustration of a person in a wheelchair, sitting at a table, working on their laptop.",
      ),
    },
  ];

  const isSm = useMediaQuery("sm");

  return (
    <div className="ph8 pt8 pb18" style={isSm ? {"--w": 200} : {}}>
      <div className="maxw80 ma df fdc">
        <SectionHeader tag={i18n.t("Life at Carbon Health")} header={i18n.t("Our benefits")} />
        <div className="dg af gg10 mt14">
          {data.map(item => (
            <div key={item.img} className="df fdc maxw22 mb12 mb0-sm">
              <div>
                <NextImage
                  src={item.img}
                  height={isSm ? 140 : 190}
                  width={isSm ? 140 : 190}
                  alt={item.alt}
                />
              </div>
              <div className="ls-3 fs28 font-cm mb3 lh12">{item.header}</div>
              <div className="font-im gray600 lh14">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurBenefits;
